import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/permissions/route-guard";

export const Route = createFileRoute("/_authenticated/logistics/box-deliveries")({
  component: BoxDeliveriesLayout,
});

function BoxDeliveriesLayout() {
  return (
    <RouteGuard module="box_deliveries" action="read">
      <Outlet />
    </RouteGuard>
  );
}
